import { render, staticRenderFns } from "./page-layout.vue?vue&type=template&id=51875b52&scoped=true&"
import script from "./page-layout.vue?vue&type=script&lang=js&"
export * from "./page-layout.vue?vue&type=script&lang=js&"
import style0 from "./page-layout.vue?vue&type=style&index=0&id=51875b52&prod&scoped=true&lang=css&"
import style1 from "./page-layout.vue?vue&type=style&index=1&id=51875b52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.3_vue-template-compiler@2.6.10_webpack@5.75.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51875b52",
  null
  
)

export default component.exports